import React, { memo, useEffect, useState } from "react";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Box } from "@mui/material";
import IBaseTextAreaProps from "./types";
import styles from "./BaseTextArea.styled";

const BaseTextArea: React.FC<IBaseTextAreaProps> = ({
  id,
  name,
  minRows = 1,
  formik,
  placeholder,
  maxLength,
  initialValue,
}) => {
  const [inputValue, setInputValue] = useState(initialValue || "");
  const [charactersCounter, setCharactersCounter] = useState<number>(0);

  useEffect(() => {
    if (initialValue) {
      setInputValue(initialValue);
    } else {
      setInputValue("");
    }
  }, [initialValue]);

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    if (maxLength) {
      if (value.length < maxLength || value.length !== charactersCounter) {
        setCharactersCounter(value.length);
      }
    }
    setInputValue(value);
    formik.setFieldValue(name, value);
  };

  return (
    <Box sx={styles.textareaWrap}>
      <TextareaAutosize
        id={id}
        name={name}
        minRows={minRows}
        onChange={handleInputChange}
        value={formik.values[name] || inputValue}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      <Box sx={styles.counter}>
        {charactersCounter}/{maxLength}
      </Box>
    </Box>
  );
};

export default memo(BaseTextArea);
